import {Box, Flex, FormLabel, Input, Stack, Text} from '@chakra-ui/core';
import {debounce} from 'lodash';
import React from 'react';
import {yellow} from 'styles/constants';
import {Button} from './Button';

const SidebarSettings = ({
	handleSubmit,
	formFields,
	displayValues,
	defaults,
	handleOnChange,
	register,
	parseNumber,
	setSettingsOpen,
	warnings,
}) => {
	return (
		<Box>
			<Box bg={yellow} p={6} pt={2} rounded={2}>
				<form onSubmit={handleSubmit}>
					{formFields.map((k, index) => {
						return (
							<React.Fragment key={index}>
								{k === 'production,(Tonnes/hour)' && (
									<Text fontWeight="bold" pt={2}>
										Case example calculations
									</Text>
								)}
								<Stack key={index} my={4} spacing={1}>
									<FormLabel fontSize={'sm'}>{displayValues[k] || k}</FormLabel>
									{warnings[k] ? <p style={{color: 'red'}}>{warnings[k]}</p> : null}
									<Flex>
										<Input
											pl={3}
											color={'#222'}
											placeholder={k}
											defaultValue={defaults[k]}
											onInput={debounce(() => handleOnChange(), 500)}
											{...register(k, {setValueAs: parseNumber, min: 0})}
										/>
									</Flex>
								</Stack>
							</React.Fragment>
						);
					})}
				</form>
			</Box>
			<Button border={'3px solid #333'} mt={4} onClick={() => setSettingsOpen(false)}>
				Save
			</Button>
		</Box>
	);
};

export default SidebarSettings;
